<template>
  <div class="page">
    <div class="page-con">
      <a-steps
        v-model="current"
        type="navigation"
        size="small"
        :style="stepStyle"
      >
        <a-step
          v-for="(item, index) in stepList"
          :key="index"
          :status="item.status"
          :title="item.title"
          disabled
        />
      </a-steps>
      <div class="steps-content">
        <login v-if="current == 0" @loginSuccess="loginSuccess"></login>
        <ticket-list
          v-if="current == 1"
          @selectTicket="selectTicket"
          @getDetails="getDetails"
        ></ticket-list>
        <visit-date v-if="current == 2" @selectDate="selectDate"></visit-date>
        <write-mes
          v-if="current == 3"
          @orderSuccess="orderSuccess"
          @leftStep="leftStep"
        ></write-mes>
        <order-success v-if="current == 4"></order-success>
      </div>
      <div v-if="rich" style="margin:20px 0;padding-bottom:20px ;">
        <div v-html="desc" class="ql-editor" />
      </div>
    </div>
    <!-- <div class="left">
      <img src="../assets/images/left.jpg" alt="" />
    </div>
    <div class="right">
      <img src="../assets/images/right.png" alt="" />
    </div> -->
  </div>
</template>
<script>
import Login from "./Login";
import TicketList from "./TicketList";
import VisitDate from "./VisitDate";
import WriteMes from "./WriteMes";
import OrderSuccess from "./OrderSuccess";
import { getAccessToken } from "../utils/cookie";

export default {
  components: {
    Login,
    TicketList,
    VisitDate,
    WriteMes,
    OrderSuccess
  },
  data() {
    return {
      current: 0,
      stepStyle: {
        marginBottom: "20px",
        boxShadow: "0px -1px 0 0 #e8e8e8 inset"
      },
      cookie: "",
      stepList: [
        {
          status: "process",
          title: "登陆",
          disabled: true
        },
        {
          status: "wait",
          title: "选择门票",
          disabled: true
        },
        {
          status: "wait",
          title: "选择参观日期",
          disabled: true
        },
        {
          status: "wait",
          title: "填写预约信息",
          disabled: true
        },
        {
          status: "wait",
          title: "预约成功",
          disabled: true
        }
      ],
      rich: false,
      desc: ""
    };
  },
  methods: {
    // 登录成功
    loginSuccess() {
      location.reload();
      this.getCookie();
    },
    // 获取完详情显示富文本
    getDetails() {
      this.rich = true;
      this.desc = sessionStorage.getItem("desc");
    },
    // 页面刷新读取cookie 如果有则直接到选座门票界面
    getCookie() {
      this.cookie = getAccessToken();
      if (this.cookie) {
        this.current = 1;
        this.stepList[0].status = "finish";
        this.stepList[1].status = "process";
      }
    },
    // 选取完门票进入日期选择界面 并获取门票详情
    selectTicket(id) {
      sessionStorage.setItem("tid", id);
      this.current = 2;
      this.stepList[1].status = "finish";
      this.stepList[2].status = "process";
    },
    // 选择时间下一步  或者上一步
    selectDate(type) {
      if (type === "next") {
        this.current = 3;
        this.stepList[2].status = "finish";
        this.stepList[3].status = "process";
      } else {
        this.current = 1;
        this.stepList[1].status = "process";
        this.stepList[2].status = "wait";
      }
    },
    // 预约成功下一步
    orderSuccess() {
      this.current = 4;
      this.stepList[3].status = "finish";
      this.stepList[4].status = "process";
    },
    // 填写信息返回上一步
    leftStep() {
      this.current = 2;
      this.stepList[2].status = "process";
      this.stepList[3].status = "wait";
    }
  },
  created() {
    this.getCookie();
  }
};
</script>
<style scoped lang="less">
.page {
  position: relative;
}
.left,
.right {
  position: absolute;
  top: 80px;
  img {
    width: 230px;
  }
}
.left {
  left: 60px;
}
.right {
  right: 60px;
}
.page-con {
  width: 1200px;
  margin: 10px auto;
}
.steps-content {
  border: 3px dashed #e9e9e9;
  border-radius: 6px;
  /* background-color: #fafafa; */
  min-height: 500px;
  text-align: center;
}
</style>
